import React from 'react'
import styled from 'styled-components'
import { defs } from 'components/Shared/defs'
import { device } from 'components/Shared/device'

import { useDayforceBookingsContextValue } from '../context/DayforceBookingsProvider'
import { Input, Loading } from '@workwhile/ui'

export const DayforceBookingsFilterBar = () => {
  const {
    state: { filters, isFetching },
    actions: { setFilters },
  } = useDayforceBookingsContextValue()

  return (
    <FilterBarWrapper showBorderTop showBorderBottom>
      <Input
        type="text"
        placeholder="Search Dayforce bookings"
        value={filters.searchTerm}
        onChange={(e) => setFilters({ searchTerm: e.currentTarget.value })}
        style={{ width: '400px' }}
      />
      {isFetching ? <Loading /> : null}
    </FilterBarWrapper>
  )
}

const FilterBarWrapper = styled.div<{
  showBorderTop?: boolean
  showBorderBottom?: boolean
}>`
  border-bottom: ${(props) => (props.showBorderBottom ? '1px solid' : null)};
  border-top: ${(props) => (props.showBorderTop ? '1px solid' : null)};
  border-color: ${defs.veryLightBlack};
  padding: ${defs.paddingS};
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #fafafa;
  @media ${device.smallerThanMobileL} {
    font-size: ${defs.fontS};
    height: 100%;
    padding-left: ${defs.paddingM};
  }
`
